export default "__VITE_ASSET__CJcYdntX__"